import { cx } from '../../cx'

export interface AvatarProps {
  src?: string
  alt?: string
  /** Falls back to initials derived from this when there is no image. */
  name?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('')
}

export function Avatar({ src, alt, name, size = 'md', className }: AvatarProps) {
  const cls = cx('bui-avatar', size !== 'md' && `bui-avatar-${size}`, className)
  if (src) return <span className={cls}><img src={src} alt={alt ?? name ?? ''} /></span>
  // Initials are decorative when a name is already shown elsewhere; the title
  // attribute keeps the full name reachable without announcing "JD" as content.
  return (
    <span className={cls} title={name} aria-hidden={!name || undefined}>
      {name ? initials(name) : null}
    </span>
  )
}
